import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const RecordingHistorySlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getRecordingHistory: builder.query({
            query: (arg: any) => {
                const { employeeNumber, fromDate } = arg;
                return {
                    url: constants.GET_RECORDING_HISTORY,
                    params: { employeeNumber, fromDate },
                };
            },
            providesTags: ['Coaching'],
        }),
        getRecordingStream: builder.query({
            query: (arg: any) => {
                const { fileName } = arg;
                return {
                    url: constants.GET_RECORDING_STREAM,
                    params: { fileName },
                };
            },
            providesTags: ['Coaching'],
        }),
    }),
});

export const { useGetRecordingHistoryQuery, useGetRecordingStreamQuery } = RecordingHistorySlice;
